import { v4 as uuidv4 } from 'uuid';

export function getOrCreateDeviceId(): string {
  try {
    const uuid = localStorage.getItem('deviceId');
    if (uuid) {
      return uuid;
    }

    const newUuid = self.crypto?.randomUUID?.() ?? uuidv4();
    localStorage.setItem('deviceId', newUuid);
    return newUuid;
  } catch {
    return self.crypto?.randomUUID?.() ?? uuidv4();
  }
}
